import RestClient from './RestClient';
import API_ENDPOINTS from './apiConfig';

export default class AuthManager {
  /**
   * gets current logged in user from backend and stores in local storage
   * @returns
   */
  static async initialize() {
    if (this.isLoggedIn()) {
      try {
        const response = await RestClient.get(API_ENDPOINTS.AUTH.CURRENT_USER);
        return response;
      } catch (e) {
      }
    }
  }

  static isLoggedIn() {
    return !!this.getFullToken();
  }

  static getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  static async logout(redirectTo = '/app/account/signin') {
    await RestClient.request(API_ENDPOINTS.AUTH.LOGOUT, { method: 'DELETE' });
    this.removeFullToken();
    this.removeResellerIdFromLocalStorage();
    this.removeQueryParams();
    if (redirectTo) {
      window.location = redirectTo;
    }
  }

  static persistUserToLocalStorage(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
  // TODO: reseller_uuid should not be stored in local storage
  // https://payuindia.atlassian.net/browse/PPP-207
  static persistResellerIdToLocalStorage(resellerUuid) {
    localStorage.setItem('reseller_uuid', JSON.stringify(resellerUuid));
  }
  static getResellerId() {
    try {
      return JSON.parse(window.localStorage.getItem('reseller_uuid'));
    } catch (e) {
      return null;
    }
  }

  static removeUserFromLocalStorage() {
    localStorage.removeItem('user');
  }
  static removeResellerIdFromLocalStorage() {
    localStorage.removeItem('reseller_uuid');
  }


  static getHubToken(hubUser) {
    if (hubUser && hubUser.attributes) {
      const { 'limited-token': token } = hubUser.attributes;
      return token['access-token'];
    }
    return null;
  }

  static persistFullToken(tokenData) {
    let data;
    try {
      const tokenLifeTime = new Date();
        tokenLifeTime.setSeconds(tokenData.expires_in);
      tokenData.tokenLifeTime = tokenLifeTime;
      data = JSON.stringify(tokenData);
    } catch (e) {
      console.warn(e);
    }
    if (!this.getFullToken()) {
      window.localStorage.setItem('tokenData', data);
    }
  }

  static getFullToken() {
    try {
      return JSON.parse(window.localStorage.getItem('tokenData')).access_token;
    } catch (e) {
      return null;
    }
  }

  static getUserUUID() {
    try {
      return JSON.parse(window.localStorage.getItem('user_uuid'));
    } catch (e) {
      return null;
    }
  }

  static getUserId() {
    try {
      return JSON.parse(window.localStorage.getItem('tokenData')).user_uuid;
    } catch (e) {
      return null;
    }
  }

  static removeFullToken() {
    return window.localStorage.removeItem('tokenData');
  }

  static isSessionActive() {
    try {
      const tokenData = JSON.parse(window.localStorage.getItem('tokenData'));
      return Date.parse(tokenData.tokenLifeTime) > Date.now();
    } catch (e) {
      return null;
    }
  }

  static removeQueryParams(){
    return window.sessionStorage.removeItem('queryString')
  }
}
